// extracted by mini-css-extract-plugin
module.exports = {"controls":"MinimizedControls_controls__GHhd_","controlsWrapper":"MinimizedControls_controlsWrapper__Q1k_S","controlGroup":"MinimizedControls_controlGroup__bFD0W"};